module.exports = __webpack_public_path__ + "img/user6-img1.0bb0eb21.jpg";